// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4357":"18e4ba84c979d8aa","4446":"e7725cd47c1278a3"}[chunkId] + ".js";
};